import type { JointDefinition } from './JointAngles';
import type { SkeletonDefinition } from './PoseEngine';
import type { Link } from '../types';

export const MOVENET_NODE_NAMES: readonly string[] = [
  'nose',
  'left_eye',
  'right_eye',
  'left_ear',
  'right_ear',
  'left_shoulder',
  'right_shoulder',
  'left_elbow',
  'right_elbow',
  'left_wrist',
  'right_wrist',
  'left_hip',
  'right_hip',
  'left_knee',
  'right_knee',
  'left_ankle',
  'right_ankle',
];

const EDGES: readonly [number, number][] = [
  [0, 1],
  [1, 3],
  [0, 2],
  [2, 4],
  [5, 6],
  [5, 7],
  [7, 9],
  [6, 8],
  [8, 10],
  [5, 11],
  [6, 12],
  [11, 12],
  [11, 13],
  [13, 15],
  [12, 14],
  [14, 16],
];

export const MOVENET_LINKS: readonly Link[] = EDGES.map(([source, target]) => ({
  sourceId: source,
  targetId: target,
  label: `${MOVENET_NODE_NAMES[source]}→${MOVENET_NODE_NAMES[target]}`,
}));

export const MOVENET_JOINT_DEFINITIONS: readonly JointDefinition[] = [
  { key: 'leftElbow', label: 'L Elbow', a: 5, b: 7, c: 9, color: '#62d9ff' },
  { key: 'rightElbow', label: 'R Elbow', a: 6, b: 8, c: 10, color: '#ff5477' },
  { key: 'leftShoulder', label: 'L Shoulder', a: 7, b: 5, c: 11, color: '#7affa0' },
  { key: 'rightShoulder', label: 'R Shoulder', a: 8, b: 6, c: 12, color: '#ffb347' },
  { key: 'leftHip', label: 'L Hip', a: 5, b: 11, c: 13, color: '#c080ff' },
  { key: 'rightHip', label: 'R Hip', a: 6, b: 12, c: 14, color: '#ffd966' },
  { key: 'leftKnee', label: 'L Knee', a: 11, b: 13, c: 15, color: '#5ee0c9' },
  { key: 'rightKnee', label: 'R Knee', a: 12, b: 14, c: 16, color: '#ff77d9' },
];

export const MOVENET_SKELETON: SkeletonDefinition = {
  nodeNames: MOVENET_NODE_NAMES,
  links: MOVENET_LINKS,
  jointDefs: MOVENET_JOINT_DEFINITIONS,
};
